/**
 * FilterIcon Component
 *
 * Funnel/filter icon for filter actions.
 */

export function FilterIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M6.50249 6.5643C6.50255 6.03525 6.68582 5.52064 7.02358 5.1013L9.97349 1.43957H2.0266L4.9765 5.1013C5.31426 5.52064 5.49753 6.03525 5.4976 6.5643V10.9205L6.50249 11.8802V6.5643ZM8.00983 13.0386L7.99707 13.1933C7.88412 13.8928 7.01601 14.2365 6.41809 13.8184L6.29444 13.7172L4.28466 11.7977C4.11975 11.6403 4.01799 11.4336 3.99516 11.2139L3.99026 11.1192V6.5643C3.99021 6.40559 3.94914 6.25014 3.87152 6.11162L3.78221 5.97947L0.210137 1.54454C-0.266247 0.952812 0.117942 0.112861 0.854878 0.0103094L1.00699 0H10.9931C11.8267 0 12.298 0.913421 11.7899 1.54454L8.21787 5.97947C8.0829 6.14713 8.00989 6.35282 8.00983 6.5643V13.0386Z"
        fill="currentColor"
      />
    </svg>
  );
}
